const RESULT_TYPES = {
  KEYWORD: "keyword",
  PLACE: "place",
  TOPIC: "topic",
};

export default RESULT_TYPES;
